import VerbatimImageVideoTag from './verbatimImageVideoTag'
export default VerbatimImageVideoTag
